import React from 'react';
import DataTable from '../DataTable/DataTable';
import * as helper from '../util/helper';
import * as UrlTools from '../util/url';
import AccLoading from './AccLoading/AccLoading';
import { getExtensionCmp } from '../util/extension';
require('./DetailPage.scss');

class DetailPageRelativeView extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            currentPageModuleData: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.sub_cmps &&
            nextProps.sub_cmps.length > 0 &&
            nextProps.sub_cmps[0] != this.props.sub_cmps[0]
        ) {
            this.setState({ currentPageModuleData: nextProps.sub_cmps[0] });
        }
    }

    concatRelativeCmpId(data) {
        if (!data.hasOwnProperty('sub_cmps') || data.sub_cmps.length <= 0) {
            return null;
        }

        data.sub_cmps.forEach(cmp => {
            if (cmp.hasOwnProperty('cmp_id')) {
                cmp.cmp_id = cmp.cmp_id + '_' + data.cmp_id;
            }
            if (cmp.hasOwnProperty('sub_cmps')) {
                if (!Array.isArray(cmp.sub_cmps)) {
                    cmp.sub_cmps = Object.values(cmp.sub_cmps);
                }

                this.concatRelativeCmpId(cmp);
            }
        });
    }

    componentDidMount() {
        const { fetchIndexFail } = this.props.translation;
        let fetchUrl = helper.getAPI('FetchPageModule');
        const params = {
            viewName: this.props.cmp_data.viewName,
            metaObjName: this.props.detailPage.cmp_data.metaObjectName,
            id: this.props.detailPage.cmp_data.dataID,
            detailViewName: this.props.cmp_data.currentDetailPageViewName,
            formState: 'show',
            app: BSGlobal.application
        };

        const conParam = UrlTools.getConnectSymbol(fetchUrl);
        fetchUrl = fetchUrl + conParam + UrlTools.serializeUrl(params);
        const successCallBack = function(response) {
            this.concatRelativeCmpId(response);
            if (response.sub_cmps && response.sub_cmps[0]) {
                const tableCmp =
                    response.sub_cmps[0] &&
                    response.sub_cmps[0].sub_cmps.find(item => {
                        return (
                            item.cmp_type == 'table_list' ||
                            item.cmp_type.toLowerCase() == 'tablelist'
                        );
                    });
                this.setState({ currentPageModuleData: tableCmp });
            }
        }.bind(this);
        const failureCallBack = function(error) {
            let tipInfo = {
                message: error.message || fetchIndexFail,
                type: 'error'
            };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.actions.showTip(tipInfo);
        }.bind(this);
        fetchUrl = helper.ajaxUrlCompletionInCachePage(fetchUrl);
        window.CommonFetch &&
            window.CommonFetch(fetchUrl, {}, successCallBack, failureCallBack);
    }

    componentDidUpdate() {
        this.props.getWidgetHtmlHeight && this.props.getWidgetHtmlHeight();
    }

    getPageContext() {
        const pageContext = {
            DataId: this.props.detailPage.cmp_data.dataID,
            currentDetailPageViewName: this.props.cmp_data
                .currentDetailPageViewName,
            metaObjName: this.props.detailPage.cmp_data.metaObjectName,
            viewName: this.props.detailPage.cmp_data.viewName
        };
        return pageContext;
    }

    onTouchMore() {
        this.props.onTouchMore && this.props.onTouchMore();
    }

    renderContent() {
        const cmpType = this.state.currentPageModuleData.cmp_type;
        // 区分相关对象
        const moduleID = this.props.cmp_data && this.props.cmp_data.viewName;
        const picArr = [1, 2, 3, 4];
        let index = this.props.accItemIndex;
        let num = picArr[index % picArr.length];
        let showColumn = 5;
        let rowsLimit = 4;
        if (
            this.state.currentPageModuleData &&
            this.state.currentPageModuleData.cmp_data
        ) {
            showColumn =
                this.state.currentPageModuleData.cmp_data.showColumn || 5;
            rowsLimit =
                this.state.currentPageModuleData.cmp_data.rowsLimit || 4;
        }

        const DestCmp = getExtensionCmp(this.props) || DataTable;
        switch (cmpType) {
            case 'TableList':
                //用于组装相关列表详情页里有to index的按钮url地址
                const queryObject = helper.getQueryObject();
                let BasePageModuleObj = {
                    metaKey: helper.guid(),
                    fromURL: 'homedetail',
                    pObjectDataID: this.props.detailPage.cmp_data.dataID,
                    viewName: this.props.cmp_data.viewName,
                    metaObjName: this.props.detailPage.cmp_data.metaObjectName,
                    showMenu: this.props.showMenu,
                    showBack: this.props.showBack,
                    viewpath: 'pageModule',
                    detailViewName:
                        queryObject && queryObject.detailViewName
                            ? queryObject.detailViewName
                            : this.props.detailPage.cmp_data.viewName,
                    currentDetailPageViewName: this.props.cmp_data
                        .currentDetailPageViewName,
                    mainDetailViewName: this.props.detailPage.cmp_data.viewName,
                    moduleID: this.props.cmp_data.viewName,
                    formState: queryObject.formState
                };
                return (
                    <DestCmp
                        ref="table"
                        basePageModule={JSON.stringify(BasePageModuleObj)}
                        extendProps={this.state.currentPageModuleData}
                        cls="onepage_table_list_item"
                        {...this.state.currentPageModuleData}
                        moduleID={moduleID}
                        num={num}
                        title={this.props.cmp_data.title || ''}
                        queryUrl={helper.getQueryObject()} // this.props.query
                        actions={this.props.actions}
                        showTableTitle={false}
                        loadData={false}
                        showColumn={showColumn}
                        rowsLimit={rowsLimit}
                        tableAjaxParam={{ page_context: this.getPageContext() }}
                        disableRemberPosition={true}
                        isNoShowRowButton={true}
                        showMoreBottom={true}
                        noBottomButton={true}
                        onTouchMore={this.onTouchMore.bind(this)}
                        accLoading={true}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        if (!this.state.currentPageModuleData) {
            return (
                <AccLoading
                    getWidgetHtmlHeight={this.props.getWidgetHtmlHeight}
                />
            );
        }
        return this.renderContent();
    }
}

export default DetailPageRelativeView;



// WEBPACK FOOTER //
// ./src/components/DetailPage/StandardRelativeView.js